<template>
  <div class="person">
    <div class="top-box">
      <div class="info">
        <section v-if="user_id" class="login" @click="onInfo">
          <div class="avatar">
            <img :src="userInfo.avatar || headerImg" />
          </div>
          <div class="extra">
            <p class="name">{{userInfo.nickname}}</p>
            <p class="vip" @click.stop="onVip" v-if="config.switch_vip_module != '0'">
              <span>{{userInfo.is_vip ? '续费会员' : '开通会员'}}></span>
            </p>
          </div>
        </section>
        <section v-else class="no-login" @click="onLogin">
          <div class="avatar">
            <img src="~@/assets/images/avatar.png" />
          </div>
          <p>登录/注册</p>
        </section>
      </div>
      <div class="mine">
        <div
          v-for="(item, index) in mineList"
          :key="index"
          class="mine-item"
          :class="item.style"
          @click="onMineItem(item)"
        >
          <p class="count">{{item.count}}</p>
          <p class="name">{{item.name}}</p>
          <p class="note">{{item.note}}</p>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <ul v-for="(menuItem, index) in menusList" :key="index">
        <li
          v-for="(item, index) in menuItem"
          :key="index"
          @click="onMenuItem(item)"
          :class="item.style || ''"
          v-show="item.hidden != '0'"
        >
          <img class="icon-menu" :src="item.icon" alt />
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "person",
  data() {
    return {
      userInfo: {},
      headerImg: require("@/assets/images/user_Headportrait.png"),
      newMessage: false,
      user_id: "",
      mineList: [
        {
          count: 0,
          name: "我的学习",
          note: "已购课程的学习",
          style: "my-study",
          url: "MyStudy"
        },
        // {
        //   count: 0,
        //   name: "我的预约",
        //   note: "一对一老师预约",
        //   style: "my-plan",
        //   url: "Record"
        // },
        {
          count: 0,
          name: "本周课时",
          note: "学习日历",
          style: "my-period",
          url: "StudyCalendar"
        }
      ]
    };
  },
  created() {
    this.user_id = localStorage.user_id;
    if (this.user_id) {
      this.requestUserInfo();
    }
    window.scrollTo(0, 0);
  },
  computed: {
    menusList() {
      return [
        [
          {
            name: "我的关注",
            icon: require("@/assets/images/icon-person-concern.png"),
            url: "Concern"
          },
          {
            name: "我的作业",
            icon: require("@/assets/images/homework/person-homework.png"),
            url: "Homework",
            hidden: this.config.homework_module.is_open
          },
          {
            name: "我的收藏",
            icon: require("@/assets/images/icon-person-collect.png"),
            url: "Collect"
          }
        ],
        [
          {
            name: "课程订单",
            icon: require("@/assets/images/icon-person-order-course.png"),
            url: "Order",
            query: { order_type: 2 }
          },
          {
            name: "会员订单",
            icon: require("@/assets/images/icon-person-order-vip.png"),
            url: "Order",
            query: { order_type: 3 },
            hidden: this.config.switch_study_module
          },
          // {
          //   name: "约课订单",
          //   icon: require("@/assets/images/icon-person-order-plan.png"),
          //   url: "Order",
          //   query: { order_type: 1 }
          // },
          {
            name: "图书订单",
            icon: require("@/assets/images/icon-person-order-book.png"),
            url: "Order",
            query: { order_type: 4 }
          }
        ],
        [
          {
            name: "优惠券",
            icon: require("@/assets/images/icon-person-coupon.png"),
            url: "Coupon"
          },
          {
            name: "学习卡",
            icon: require("@/assets/images/icon-person-card.png"),
            url: "Card",
            hidden: this.config.switch_study_module
          }
        ],
        [
          {
            name: "消息中心",
            icon: require("@/assets/images/icon-person-message.png"),
            url: "Message",
            style: {
              "has-message": this.newMessage
            }
          },
          {
            name: "地址管理",
            icon: require("@/assets/images/icon-person-message.png"),
            url: "Address"
          },
          {
            name: "关于我们",
            icon: require("@/assets/images/icon-person-about.png"),
            url: "About"
          },
          {
            name: "意见反馈",
            icon: require("@/assets/images/icon-person-feedback.png"),
            url: "Feedback"
          },
          {
            name: "设置",
            icon: require("@/assets/images/icon-person-options.png"),
            url: "Options"
          }
        ]
      ];
    },
    config() {
      return this.$store.state.config;
    }
  },
  methods: {
    // on event
    onLogin() {
      this.turnPage("SmsLogin");
    },
    onMineItem(item) {
      if (!item.url) return;
      this.turnPage(item.url);
    },
    onInfo() {
      this.turnPage("Info");
    },
    onVip() {
      this.turnPage("Vip");
    },
    onMenuItem(item) {
      if (item.url == "Homework") {
        this.$store.commit("IS_RESET_STATE", 1);
      }
      this.turnPage(item.url, item.query);
    },
    // other
    turnPage(name, query) {
      if (!this.user_id) {
        // 未登录 统一推到验证码登录页面
        this.$router.push({
          name: "SmsLogin"
        });
        return;
      }
      this.$router.push({
        name,
        query
      });
    },
    // rquest
    requestUserInfo() {
      this.$http.get("/api/app/userInfo").then(data => {
        this.userInfo = data;
        this.requestMessage();
        this.requestCount();
      });
    },
    requestMessage() {
      this.$http.post("/api/app/message/classifyMessage").then(data => {
        for (const i of data) {
          if (i.is_read == 0) {
            this.newMessage = true;
            break;
          }
        }
      });
    },
    requestCount() {
      this.$http.get("/api/app/getUCenterInfo").then(data => {
        this.mineList[0].count = data.courses;
        this.mineList[1].count = data.oto;
        this.mineList[2].count = data.integral;
      });
    }
  }
};
</script>
<style scoped lang="scss">
.person {
  overflow: hidden;
  padding-bottom: 150px;
  @extend %default-bg;
}
.top-box {
  height: 632px;
  background: url("~@/assets/theme-img/user_bg.png") no-repeat top center;
  background-size: 100%;
  background-color: #fff;
  position: relative;

  .info {
    overflow: hidden; //触发BFC
    .login {
      overflow: hidden; //触发BFC
      margin-top: 106px;
      position: relative;
      .avatar {
        float: left;
        margin: 0 50px 0 40px;
      }
      .extra {
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100px;
        .name {
          font-size: 34px;
          color: #fafafa;
        }
        .vip {
          margin-top: 30px;
          display: inline-block;
          width: 186px;
          height: 48px;
          border-radius: 20px;
          background: url("~@/assets/images/icon-vip.png") no-repeat;
          background-position: 15px center;
          background-size: 25px;
          background-color: rgba(0, 0, 0, 0.2);
          font-size: 24px;
          color: #fff;
          line-height: 48px;
          span {
            margin-left: 50px;
          }
        }
      }
      &:after {
        content: "";
        display: block;
        border-top: 3px solid #fff;
        border-right: 3px solid #fff;
        width: 30px;
        height: 30px;
        position: absolute;
        top: 50%;
        right: 40px;
        transform: translateY(-50%) rotate(45deg);
      }
    }
    .no-login {
      margin-top: 106px;
      @extend %flex-center;
      flex-direction: column;
      p {
        font-size: 34px;
        color: #fff;
        margin-top: 36px;
      }
    }
    .avatar {
      width: 126px;
      height: 126px;
      background-color: #bdcdf1;
      border-radius: 50%;
      @extend %flex-center;
      img {
        width: 118px;
        height: 118px;
        border-radius: 50%;
      }
    }
  }

  .mine {
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    .mine-item {
      width: 33%;
      height: 230px;
      margin: 0 40px;
      text-align: center;
      position: relative;
      .count {
        font-size: 48px;
        line-height: 120px;
      }
      .name {
        font-size: 28px;
        color: #595959;
        margin-bottom: 12px;
      }
      .note {
        font-size: 22px;
        color: #b7b7b7;
      }
      // &::after {
      //   content: "";
      //   display: block;
      //   width: 1px;
      //   height: 110px;
      //   background-color: #f5f5f5;
      //   position: absolute;
      //   top: 50%;
      //   right: 0;
      //   transform: translateY(-50%);
      // }
      &:last-child::after {
        display: none;
      }
    }
    .my-study > .count {
      color: #5bb8f5;
    }
    .my-plan > .count {
      color: #6563a4;
    }
    .my-period > .count {
      color: #4169ff;
    }
  }
}

.bottom-box {
  .icon-menu {
    width: 28px;
    // height: 26px;
    margin-right: 12px;
  }
  ul {
    background-color: #fff;
    margin: 30px 0;
    padding: 10px 30px;
    li {
      height: 110px;
      line-height: 110px;
      position: relative;
      font-size: 28px;
      color: #595959;
      * {
        vertical-align: middle;
      }
      &:before {
        content: "";
        display: block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%) rotate(45deg);
        width: 20px;
        height: 20px;
        border-top: 1px solid #b7b7b7;
        border-right: 1px solid #b7b7b7;
      }
      border-bottom: 1px solid #f5f5f5;
      &:last-child {
        border-bottom: none;
      }
    }
    li.has-message:after {
      content: "";
      display: block;
      position: absolute;
      top: 50%;
      left: 160px;
      transform: translateY(-50%);
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: red;
    }
  }
}
</style>
